/**
 * Configurator API
 * Configurator API documentation
 *
 * OpenAPI spec version: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { AbsctractProcessingLoadConf } from './absctractProcessingLoadConf';
import { AbstractStoreConf } from './abstractStoreConf';
import { KeepField } from './keepField';
import { SqlLoadConf } from './sqlLoadConf';

export interface FileProcessingLoadConf extends AbsctractProcessingLoadConf { 
    stores?: Array<AbstractStoreConf>;
    fileName?: string;
    patternWithDate?: string;
    type?: FileProcessingLoadConf.TypeEnum;
}
export namespace FileProcessingLoadConf {
    export type TypeEnum = 'CSV' | 'XLSX' | 'PDF';
    export const TypeEnum = {
        CSV: 'CSV' as TypeEnum,
        XLSX: 'XLSX' as TypeEnum,
        PDF: 'PDF' as TypeEnum
    };
}